import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var TaxForm1099IA = function TaxForm1099IA(_ref) {
  var brand = _ref.brand;
  if ((brand === null || brand === void 0 ? void 0 : brand.based_in) === "USA") {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "EkqTdQ",
      defaultMessage: [{
        "type": 0,
        "value": "Pour recevoir un formulaire fiscal 1099-K, vous devez atteindre "
      }, {
        "children": [{
          "type": 0,
          "value": "un certain chiffre d'affaires"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " sur Faire. Quand vous aurez vérifié que vous avez atteint ce chiffre d'affaires, vous pourrez afficher et télécharger votre formulaire fiscal 1099-K en procédant comme suit :"
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return CertainSaleLinkFormatting(chunks);
        },
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
      step: 1
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "VPbiI1",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Pour la livraison électronique :"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "9JoO7p",
      defaultMessage: [{
        "type": 0,
        "value": "Si vous avez demandé un formulaire fiscal 1099-K en format électronique, vous le trouverez sur votre portail Faire, dans "
      }, {
        "children": [{
          "type": 0,
          "value": "Paramètres du compte"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ", sur la page "
      }, {
        "children": [{
          "type": 0,
          "value": "Exportation et taxes"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": ". Il sera disponible dès qu'il sera prêt, généralement avant le 31 janvier."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "export-taxes");
        },
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 2
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Bnijx1",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Pour l'envoi par courrier postal :"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "+2dQY7",
      defaultMessage: [{
        "type": 0,
        "value": "Si vous avez demandé une copie papier, elle devrait vous parvenir à la mi-février. Pour éviter les retards, vérifiez que vos informations fiscales et votre adresse officielle sont à jour dans vos paramètres "
      }, {
        "children": [{
          "type": 0,
          "value": "Exportation et taxes"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "export-taxes");
        }
      }
    })))));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Qdu8Ar",
    defaultMessage: [{
      "type": 0,
      "value": "Vous ne recevrez pas de formulaire 1099-K de la part de Faire, car celui-ci n'est envoyé qu'aux marques basées aux États-Unis. Si votre marque est basée aux États-Unis, et que vous pensez que vous devriez recevoir un formulaire, contactez-nous ci-dessous."
    }]
  })));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var CertainSaleLinkFormatting = function CertainSaleLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: articlePage("360022603552"),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};